import React from 'react';

import { HerButton } from '@atlassian/ai-audio/enterprise-her';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export type EnterpriseHerButtonWrapperProps = {
	contentId: string;
	contentType: string;
};

export const EnterpriseHerButtonWrapper = ({
	contentId,
	contentType,
}: EnterpriseHerButtonWrapperProps) => {
	const { cloudId } = useSessionData();

	return <HerButton contentId={contentId} contentType={contentType} cloudId={cloudId} />;
};
